//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CoursesIntro from '@/components/courses/coursesIntro';
import CoursesFilter from '@/components/courses/coursesFilter';
import createHead from '@/utils/coursesListHead';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    CoursesIntro,
    CoursesFilter,
  },
  layout: 'scaled',
  middleware: ['coursesGuard', 'topics', 'nomenclatureTypes'],

  head() {
    const createHeadFunction = createHead.bind(this);
    return createHeadFunction();
  },
  computed: {
    ...mapGetters('courses', ['computedCoursesBranding']),
    isMx() {
      return this.$nuxt.$config.COUNTRY === 'mx';
    },
    isBr() {
      return this.$nuxt.$config.COUNTRY === 'br';
    },
  },
  created() {
    this.$store.commit('courses/setMobileFilterOpened', false);
  },
  mounted() {
    if (this.isMx || this.isBr) {
      const previewId = this.$route.query['preview_id'];
      this.fetchCoursesBranding({ previewId });
    }
  },

  methods: {
    ...mapActions('courses', ['fetchCoursesBranding']),
    onFormSubmit() {
      window?.$meter?.event({
        name: 'formSubmit',
        label: 'formAtTheEndOfTheCoursesPage',
      });
    },
    onFormSuccess() {
      window?.$meter?.event({
        name: 'formSuccess',
        label: 'formAtTheEndOfTheCoursesPage',
      });
    },
  },
};
